export default __webpack_public_path__ + "static/media/button.dc97fabb.png";